import { TDealType } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { IState } from '../../../store';

export const selectDealType = (state: IState): TDealType => state.offerData.offer.dealType;
